/*
	This form is for Mediaocean Facebook connections.  For Flashtalking Facebook connections, see FacebookVideo
*/

import React from "react";
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import { FormSection, getFormValues } from "redux-form";

import { SOCIAL_AD_TYPES } from "utils/constants";
import { SOCIAL_WIZARD } from "widgets/forms/list";
import PACController from "social/PACController";

export default function FacebookVideoMO(props){
	const formValues = useSelector(getFormValues(SOCIAL_WIZARD)) || {};
	const { assetType } = formValues[SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO] || {};

	return (
		<FormSection name={SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO}>
			<PACController
				{...props}
				adType={SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO}
				creativeAssetType={assetType}
			/>
		</FormSection>
	);
}

FacebookVideoMO.displayName = "FacebookVideoMOForm";

FacebookVideoMO.propTypes = {
	libraryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	navigationActions: PropTypes.object,
	isViewOnly: PropTypes.bool,
	isEditMode: PropTypes.bool,
	showPristineErrors: PropTypes.bool,
	doVersionsExist: PropTypes.bool,
};
